"use strict";

(function () {
  'use strict';

  function upcomingTrips(Moment, DateService) {
    return function (arr) {
      if (arr && Array.isArray(arr)) {
        var today = Moment().startOf('day');
        return arr.filter(function (item) {
          var start = Moment(DateService.formatSlashesToDashes(item.startDate));
          return today.diff(start, 'days', true) < 0 && !item.cancelDate;
        });
      } else {
        return arr;
      }
    };
  }

  upcomingTrips.$inject = ['Moment', 'DateService'];
  angular.module('filter.upcoming-trips', []).filter('upcomingTrips', upcomingTrips);
})();